import theme from '@d-id/studio/src/theme';
import styled from '@emotion/styled';
import { GroundingStateItem } from './GroundingSelection';

const OptionContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
`;

const Title = styled.p`
    color: ${theme.colors.secondary.main};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.28px;
`;

const SubTitle = styled.p`
    color: ${theme.colors.black[700]};
    text-align: start;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

interface Props {
    item: GroundingStateItem;
}

export const GroundingOption = ({ item: { title, subtitle } }: Props) => (
    <OptionContainer>
        <Title>{title}</Title>
        <SubTitle>{subtitle}</SubTitle>
    </OptionContainer>
);
